/**
 * dateFormat
 *
 * Formats a unix timestamp as "MMM DD, YYYY HH:mm:ss" in UTC.
 */
export const dateFormat = (unix) => {
  if (!unix) return '—';
  return new Intl.DateTimeFormat('en-US', {
    timeZone:    'UTC',
    month:       'short',
    day:         '2-digit',
    year:        'numeric',
    hour:        '2-digit',
    minute:      '2-digit',
    second:      '2-digit',
    hour12:      false,
  }).format(new Date(unix * 1000));
};

export default dateFormat;
